"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var withContext_1 = require("../../utils/hoc/withContext");
var CheckboxWithinContext_1 = require("./CheckboxWithinContext");
/**
 * The `Checkbox` component is a wrapper for an `<input type="checkbox">` HTML element.
 * The label must be set and should contain text or phrasing content.
 */
exports.Checkbox = withContext_1.withErgoElementsContext('Checkbox', CheckboxWithinContext_1.CheckboxWithinContext);
exports.default = exports.Checkbox;
__export(require("./CheckboxWithinContext"));
//# sourceMappingURL=Checkbox.js.map